// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","headerHidden":"Header_headerHidden__oVM69","headerVisible":"Header_headerVisible__jWRHi","nav":"Header_nav__IIF23"};